import { Component } from '@angular/core';

@Component({
  selector: 'app-digital-marketing',
  imports: [],
  templateUrl: './digital-marketing.component.html',
  styleUrl: './digital-marketing.component.scss',
})
export class DigitalMarketingComponent {}
